import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { withTheme } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import { Highlight } from "../../../Styled-Components/styles";

import { getTreesPlanted, getCarbonOffset } from "../../../Functions/functions";
import { times } from "lodash";
import { Typography } from "@material-ui/core";
import { ImInfo } from "react-icons/im";
import { FaTree } from "react-icons/fa";

const Trees = styled.div`
  line-height: 1.5em;
  max-height: 9em;
  width: 80%;

  overflow: hidden;
  margin: 2vh auto;
`;

const ImpactVisualisation = (props) => {
  const [displayTrees, setDisplayTrees] = useState("");
  useEffect(() => {
    const trees = [];
    const treeTypes = ["🌲"];
    const maxTrees = 200;
    const numberOfTrees = props.payment < maxTrees ? props.payment : maxTrees;
    times(numberOfTrees, () => trees.push(treeTypes));
    setDisplayTrees(trees);
  }, [props.payment]);
  return (
    <div
      style={{
        overflow: "hidden",
        width: "60vw",
        margin: "0 auto",
      }}
    >
      <Typography variant="h4">Your Impact</Typography>
      <Trees>{displayTrees}</Trees>
      <div>
        <Typography variant="h6">
          You will plant{" "}
          <Highlight>
            <div>{Math.round(getTreesPlanted(props.payment)).toLocaleString()} trees</div>
            <FaTree color={props.theme.palette.primary.dark} />
          </Highlight>{" "}
          which will help offset{" "}
          <Tooltip title="This is an estimate" arrow>
            <Highlight>
              <div>
                {Math.round(getCarbonOffset(props.payment, "tonnes")).toLocaleString()} tonnes CO
                <sub>2</sub>
              </div>
              <ImInfo color={props.theme.palette.primary.dark} />
            </Highlight>
          </Tooltip>
        </Typography>
      </div>
    </div>
  );
};

export default withTheme(ImpactVisualisation);
